module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full h-full"
  }, [_c('StudentsTable')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-48d4d771!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/tabs/IndividualSummary.vue
// module id = 1167
// module chunks = 61